// extracted by mini-css-extract-plugin
export default {"class":"CommonClass_class__xXaal","label":"CommonClass_label__iQGMP","value":"CommonClass_value__6wQ61","input":"CommonClass_input__3lP25","unsaved":"CommonClass_unsaved__TO48b"};